import React, { useState } from "react";

const SolicitarApiKeyPage = () => {
    const [formData, setFormData] = useState({
        nombre: "",
        email: "",
        empresa: "",
        rol: "",
        estimacion: "",
        descripcion: ""
    });

    const [enviado, setEnviado] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Aquí iría la lógica para enviar los datos al backend o a un servicio externo
        console.log("Solicitud enviada:", formData);
        setEnviado(true);
    };

    return (
        <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow mt-6 mb-12">
            <h1 className="text-2xl font-bold text-brand-blue mb-4">Solicitar acceso a la API</h1>
            {enviado ? (
                <p className="text-green-600 font-semibold">¡Tu solicitud ha sido enviada correctamente!</p>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Nombre completo</label>
                        <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required className="w-full border rounded p-2" />
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Correo electrónico</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full border rounded p-2" />
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Empresa</label>
                        <input type="text" name="empresa" value={formData.empresa} onChange={handleChange} required className="w-full border rounded p-2" />
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Rol en la empresa</label>
                        <input type="text" name="rol" value={formData.rol} onChange={handleChange} required className="w-full border rounded p-2" />
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Estimación de uso mensual</label>
                        <select name="estimacion" value={formData.estimacion} onChange={handleChange} required className="w-full border rounded p-2">
                            <option value="">Selecciona una opción</option>
                            <option value="<1000">Menos de 1.000 peticiones/mes</option>
                            <option value="1000-10000">Entre 1.000 y 10.000</option>
                            <option value=">10000">Más de 10.000</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Descripción del proyecto y motivo de uso</label>
                        <textarea name="descripcion" value={formData.descripcion} onChange={handleChange} required className="w-full border rounded p-2" rows={5}></textarea>
                    </div>

                    <button type="submit" className="bg-brand-blue text-white px-4 py-2 rounded hover:bg-blue-700">
                        Enviar solicitud
                    </button>
                </form>
            )}
        </div>
    );
};

export default SolicitarApiKeyPage;
